import {AsyncInlineError} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {SellerRepositoriesFactory} from '../Repositories/factory.js'

class SaveVehicleDraftLocalStorageSellerUseCase extends UseCase {
  #localStorageRepository

  constructor({localStorageRepository}) {
    super()
    this.#localStorageRepository = localStorageRepository
  }

  static create({config}) {
    return new SaveVehicleDraftLocalStorageSellerUseCase({
      localStorageRepository: SellerRepositoriesFactory.localStorageSellerRepository({config})
    })
  }

  @AsyncInlineError()
  async execute({vehicleDraft} = {}) {
    const [error] = await this.#localStorageRepository.saveVehicleDraft({vehicleDraft})

    if (error) return Promise.reject(error)

    return Promise.resolve()
  }
}

export const factory = SaveVehicleDraftLocalStorageSellerUseCase.create
